import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { useAuth } from '@/hooks/useAuth';
import { Package, Save, Loader2, ArrowRight, User, Search } from 'lucide-react';
interface City {
  id: number;
  name: string;
  governorate: string;
}

export default function CreateShipmentPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
const [merchants, setMerchants] = useState<any[]>([]);
const [selectedMerchant, setSelectedMerchant] = useState('');
const isAdminOrStaff =
  user?.role === 'admin' ||
  user?.role === 'staff' ||
  user?.roleName === 'مدير النظام' ||
  user?.roleName === 'موظف';
useEffect(() => {
  if (user) {
    setForm(prev => ({
      ...prev,
      senderName: user.fullName || user.username || '',
      senderPhone: user.phone || '',
      senderAddress: user.address || '',
      senderGovernorate: user.governorate || '',
      senderCity: user.city || '',
    }));
  }
}, [user]);  
console.log("CURRENT USER:", user);  
  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState<City[]>([]);
  const [branches, setBranches] = useState<any[]>([]);
  const [shippingCost, setShippingCost] = useState(50);

const [form, setForm] = useState({
  senderName: user?.fullName || user?.username || '',
  senderPhone: user?.phone || '',
  senderAddress: user?.address || '',
  senderGovernorate: user?.governorate || '',
  senderCity: user?.city || '',
  senderCustomerId: null,
  receiverName: '',
  receiverPhone: '',
  receiverAddress: '',
  receiverGovernorate: '',
  receiverCity: '',
  weight: 1,
  totalAmount: 0,
  codAmount: 0,
  branchId: '',
  notes: '',
  itemsDescription: '',
});

  useEffect(() => {
    const fetchData = async () => {
      try {
const requests:any[] = [
  api.get('/api/cities?pageSize=1000'),
  api.get('/api/branches')
];

if (isAdminOrStaff) {
  requests.push(api.get('/api/users'));
}

const responses = await Promise.all(requests);

const citiesRes = responses[0];
const branchesRes = responses[1];
const usersRes = responses[2];        
if (citiesRes.data?.success) {
  const data = citiesRes.data.data;
  setCities(Array.isArray(data) ? data : (data?.items || []));
}

if (branchesRes.data?.success) {
  const data = branchesRes.data.data;
  setBranches(Array.isArray(data) ? data : (data?.items || []));
}

if (usersRes?.data?.success) {
  const data = usersRes.data.data;

  const items = Array.isArray(data)
    ? data
    : (data?.items || []);
setMerchants(
  items.filter((u:any) =>
    u.role?.toLowerCase() === "merchant" || u.roleName?.toLowerCase() === "merchant" || u.roleName === "تاجر"
  )
);
}
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [isAdminOrStaff]);

  // استخراج قائمة المحافظات الفريدة مباشرة من بيانات المدن
  const uniqueGovernorates = Array.from(new Set(cities.map(c => c.governorate).filter(Boolean)));

  // تصفية المدن بناءً على المحافظة المختارة
  const getCitiesForGovernorate = (governorate: string) => {
    return cities.filter(c => c.governorate === governorate);
  };

  // حساب تكلفة الشحن الحقيقي من الباك إند بناءً على المناطق الفعلية
  useEffect(() => {
    const calculateCost = async () => {
      if (!form.senderCity || !form.receiverCity) {
        setShippingCost(50);
        return;
      }
      try {
        const res = await api.post('/api/Pricing/calculate', {
          senderCity: form.senderCity,
          receiverCity: form.receiverCity,
          weight: Number(form.weight) || 1,
          isExpress: false,
          isFragile: false,
        });
        if (res.data?.success) {
          setShippingCost(res.data.data.price);
        }
      } catch (error) {
        console.error('Error calculating shipping cost:', error);
        setShippingCost(50);
      }
    };
    calculateCost();
  }, [form.senderCity, form.receiverCity, form.weight]);

  // تحديث قيمة التحصيل (COD) تلقائياً = قيمة البضاعة + تكلفة الشحن
  useEffect(() => {
    const total = (Number(form.totalAmount) || 0) + shippingCost;
    setForm(prev => ({ ...prev, codAmount: total }));
  }, [form.totalAmount, shippingCost]);

  const handleChange = (field: string, value: any) => {
    setForm(prev => {
      const newForm = { ...prev, [field]: value };
      if (field === 'receiverGovernorate') newForm.receiverCity = '';
      if (field === 'senderGovernorate') newForm.senderCity = '';
      return newForm;
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
const payload = {
  merchantId: selectedMerchant ? selectedMerchant : undefined,
  senderCustomerId: undefined,
        senderName: form.senderName,
        senderPhone: form.senderPhone,
        senderAddress: form.senderAddress,
        senderCity: form.senderCity,
        receiverName: form.receiverName,
        receiverPhone: form.receiverPhone,
        receiverAddress: form.receiverAddress,
        receiverCity: form.receiverCity,
        weight: Number(form.weight),
        totalAmount: Number(form.totalAmount) + shippingCost,
        codAmount: Number(form.codAmount),
        branchId: form.branchId ? Number(form.branchId) : undefined,
        deliveryNotes: form.notes,
        description: form.itemsDescription,
      };
      
      console.log("SEND SHIPMENT:", payload);
      const res = await api.post('/api/shipments', payload);
      if (res.data.success) {
        alert('تم إنشاء الشحنة بنجاح!');
        navigate('/shipments');
      } else {
        alert(res.data.message || 'خطأ في الحفظ');
      }
    } catch (error: any) {
      console.error(error);
      alert(error.response?.data?.message || 'حدث خطأ');
    } finally {
      setLoading(false);
    }
  };

  const inputClass = "w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition bg-white";
  const labelClass = "block text-xs font-bold text-gray-700 mb-1";

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-orange-50/30 p-6" dir="rtl">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center gap-3 mb-8 bg-white p-4 rounded-2xl shadow-sm border border-gray-100">
          <button onClick={() => navigate('/shipments')} className="p-2 hover:bg-gray-100 rounded-full transition">
            <ArrowRight className="w-6 h-6 text-gray-600" />
          </button>
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center shadow-lg">
              <Package className="w-7 h-7 text-white" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">إنشاء شحنة جديدة</h1>
              <p className="text-gray-500 text-sm">أدخل بيانات الشحنة والمستلم</p>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="bg-white rounded-2xl border border-gray-100 p-6 shadow-sm">
<div className="flex items-center gap-2 mb-6 border-b border-gray-100 pb-3">
  <User className="w-5 h-5 text-orange-600" />
  <h2 className="text-lg font-bold text-gray-900">بيانات المرسل</h2>
</div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

{isAdminOrStaff && (
  <div className="mb-4">
    <label className={labelClass}>
      اختيار التاجر
    </label>

    <select
      className={inputClass}
      value={selectedMerchant}
      onChange={(e) => {
        const id = e.target.value;
        setSelectedMerchant(id);

        const merchant = merchants.find(
          (m: any) => String(m.id) === id
        );

        if (merchant) {
          setForm(prev => ({
            ...prev,
senderName: merchant.name || merchant.username || '',
senderPhone: merchant.phone || '',
senderAddress: merchant.address || ''
          }));
        }
      }}
    >
      <option value="">
        اختر التاجر
      </option>

      {merchants.map((m: any) => (
        <option key={m.id} value={m.id}>
          {m.name || m.username}
        </option>
      ))}
    </select>
  </div>
)}
              <div>
                <label className={labelClass}>اسم المرسل *</label>
                <input type="text" required value={form.senderName} onChange={e => handleChange('senderName', e.target.value)} className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>رقم الهاتف</label>
                <input type="tel" value={form.senderPhone} onChange={e => handleChange('senderPhone', e.target.value)} className={inputClass} placeholder="01xxxxxxxxx" />
              </div>
              <div>
                <label className={labelClass}>المحافظة</label>
                <select value={form.senderGovernorate} onChange={e => handleChange('senderGovernorate', e.target.value)} className={inputClass}>
                  <option value="">اختر المحافظة</option>
                  {uniqueGovernorates.map((gov, idx) => (
                    <option key={idx} value={gov}>{gov}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className={labelClass}>المدينة / المركز</label>
                <select value={form.senderCity} onChange={e => handleChange('senderCity', e.target.value)} className={inputClass} disabled={!form.senderGovernorate}>
                  <option value="">اختر المدينة</option>
                  {getCitiesForGovernorate(form.senderGovernorate).map((city) => (
                    <option key={city.id} value={city.name}>{city.name}</option>
                  ))}
                </select>
              </div>
              <div className="md:col-span-2">
                <label className={labelClass}>العنوان</label>
                <input type="text" value={form.senderAddress} onChange={e => handleChange('senderAddress', e.target.value)} className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>الفرع</label>
                <select value={form.branchId} onChange={e => handleChange('branchId', e.target.value)} className={inputClass}>
                  <option value="">اختر الفرع</option>
                  {branches.map((b: any) => (
                    <option key={b.id} value={b.id}>{b.name}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl border border-gray-100 p-6 shadow-sm">
            <div className="flex items-center gap-2 mb-6 border-b border-gray-100 pb-3">
              <User className="w-5 h-5 text-green-600" />
              <h2 className="text-lg font-bold text-gray-900">بيانات المستلم</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className={labelClass}>اسم المستلم *</label>
                <input type="text" required value={form.receiverName} onChange={e => handleChange('receiverName', e.target.value)} className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>رقم الهاتف *</label>
                <input type="tel" required value={form.receiverPhone} onChange={e => handleChange('receiverPhone', e.target.value)} className={inputClass} placeholder="01xxxxxxxxx" />
              </div>
              <div>
                <label className={labelClass}>المحافظة *</label>
                <select required value={form.receiverGovernorate} onChange={e => handleChange('receiverGovernorate', e.target.value)} className={inputClass}>
                  <option value="">اختر المحافظة</option>
                  {uniqueGovernorates.map((gov, idx) => (
                    <option key={idx} value={gov}>{gov}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className={labelClass}>المدينة / المركز *</label>
                <select required value={form.receiverCity} onChange={e => handleChange('receiverCity', e.target.value)} className={inputClass} disabled={!form.receiverGovernorate}>
                  <option value="">اختر المدينة</option>
                  {getCitiesForGovernorate(form.receiverGovernorate).map((city) => (
                    <option key={city.id} value={city.name}>{city.name}</option>
                  ))}
                </select>
              </div>
              <div className="md:col-span-2">
                <label className={labelClass}>العنوان بالتفصيل *</label>
                <input type="text" required value={form.receiverAddress} onChange={e => handleChange('receiverAddress', e.target.value)} className={inputClass} placeholder="اسم الشارع، رقم المبنى..." />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl border border-gray-100 p-6 shadow-sm">
            <div className="flex items-center gap-2 mb-6 border-b border-gray-100 pb-3">
              <Package className="w-5 h-5 text-blue-600" />
              <h2 className="text-lg font-bold text-gray-900">تفاصيل الشحنة</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              <div>
                <label className={labelClass}>الوزن (كجم)</label>
                <input type="number" step="0.1" value={form.weight} onChange={e => handleChange('weight', e.target.value)} className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>قيمة البضاعة (ج.م)</label>
                <input type="number" value={form.totalAmount} onChange={e => handleChange('totalAmount', e.target.value)} className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>تكلفة الشحن (ج.م)</label>
                <input type="number" readOnly value={shippingCost} className={inputClass + " bg-gray-50 font-bold text-orange-600"} />
              </div>
              <div>
                <label className={labelClass}>قيمة التحصيل COD (ج.م)</label>
                <input type="number" readOnly value={form.codAmount} className={inputClass + " bg-gray-50 font-bold text-emerald-600"} />
              </div>
            </div>
            <div className="mt-4">
              <label className={labelClass}>وصف المحتويات</label>
              <input type="text" value={form.itemsDescription} onChange={e => handleChange('itemsDescription', e.target.value)} className={inputClass} placeholder="ملابس، إلكترونيات..." />
            </div>
            <div className="mt-4">
              <label className={labelClass}>ملاحظات</label>
              <textarea value={form.notes} onChange={e => handleChange('notes', e.target.value)} className={inputClass} rows={3} placeholder="أي ملاحظات إضافية..." />
            </div>
          </div>

          <div className="flex justify-end gap-3 bg-white p-4 rounded-2xl shadow-sm border border-gray-100">
            <button type="button" onClick={() => navigate('/shipments')} className="px-6 py-3 rounded-xl border border-gray-300 text-gray-700 font-bold hover:bg-gray-50 transition">
              إلغاء
            </button>
            <button type="submit" disabled={loading} className="bg-gradient-to-l from-orange-600 to-orange-700 hover:from-orange-700 hover:to-orange-800 text-white font-bold px-8 py-3 rounded-xl shadow-lg disabled:opacity-50 flex items-center gap-2 transition-all">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <Save className="w-5 h-5" />}
              {loading ? 'جاري الحفظ...' : 'حفظ الشحنة'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
